import FAQAccordion from '@/components/base/FAQAccordion';

export const faqItems = [
  {
    q: 'O que são divisórias corporativas?',
    a: 'São sistemas de divisórias para escritório que organizam ambientes sem necessidade de obra de alvenaria. Combinam perfis, painéis e vidros para criar salas, corredores e áreas privativas com estética e flexibilidade.',
  },
  {
    q: 'Qual a diferença entre divisória modular e drywall?',
    a: 'A divisória modular é um sistema pré-fabricado, geralmente removível e reaproveitável em novas configurações. O drywall é uma solução de gesso acartonado que, embora também dispense alvenaria, tem comportamento construtivo diferente e normalmente exige acabamento com massa e pintura.',
  },
  {
    q: 'Qual a melhor divisória para sala de reunião?',
    a: 'Depende das necessidades de cada ambiente. Salas que exigem privacidade sonora costumam pedir divisória acústica ou vidro duplo, enquanto espaços que priorizam luminosidade se beneficiam de divisória de vidro para escritório. Analisamos o uso de cada sala antes de recomendar a solução.',
  },
  {
    q: 'Existe divisória de vidro com maior privacidade?',
    a: 'Sim. Além do vidro simples, existem opções com diferentes níveis de privacidade visual, incluindo vidros com acabamento diferenciado e sistemas com persiana integrada entre os vidros.',
  },
  {
    q: 'É possível usar vidro duplo?',
    a: 'Sim. O vidro duplo é uma opção para ambientes que buscam maior conforto térmico e acústico. Avaliamos a viabilidade conforme a configuração do projeto.',
  },
  {
    q: 'É possível incorporar persiana?',
    a: 'Sim. Em determinadas configurações, a persiana pode ser instalada entre os vidros, preservando a estética e facilitando o controle de privacidade.',
  },
  {
    q: 'Divisórias podem ser reaproveitadas?',
    a: 'Determinados sistemas podem ser desmontados e reaproveitados em novas configurações, o que contribui para a flexibilidade do espaço ao longo do tempo.',
  },
  {
    q: 'Quanto custa um projeto de divisórias corporativas?',
    a: 'O investimento depende da quantidade de ambientes, dos sistemas especificados, dos acabamentos e dos serviços envolvidos. Nosso foco são projetos corporativos a partir de R$ 10 mil.',
  },
  {
    q: 'A Home Office Premium faz instalação?',
    a: 'Sim. Atuamos no projeto, fornecimento e instalação de divisórias corporativas, coordenando a implantação de ponta a ponta.',
  },
  {
    q: 'Vocês atendem Recife e outras cidades?',
    a: 'Sim. Atendemos projetos em Pernambuco e avaliamos projetos em todo o Nordeste conforme porte e logística.',
  },
  {
    q: 'Vocês trabalham com arquitetos?',
    a: 'Sim. Executamos e fornecemos soluções de acordo com a especificação do profissional, integrando as divisórias ao projeto de arquitetura.',
  },
];

export default function FaqSection() {
  return (
    <section className="bg-white">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-20 md:py-28">
        <div className="max-w-2xl mb-12">
          <p className="text-[12px] md:text-[13px] font-semibold tracking-[0.28em] uppercase text-primary-500 mb-4">
            Perguntas frequentes
          </p>
          <h2 className="text-foreground-950 text-[28px] md:text-[38px] font-semibold tracking-tight leading-tight">
            Divisórias corporativas, sem mistério.
          </h2>
        </div>

        <div className="max-w-3xl">
          {faqItems.map((f) => (
            <FAQAccordion key={f.q} question={f.q} answer={f.a} />
          ))}
        </div>
      </div>
    </section>
  );
}